<template>
  <iframe src="https://tithe.ly/give/?c=1401851" />
</template>

<script lang="ts">
export default {};
</script>

<style lang="scss" scoped>
iframe {
  height: 500px;
  width: 100%;
}
</style>